import React, { useState, useEffect } from 'react';
import './App.css';
import { getTrendingArticles, transformArticles, trackArticleClick } from './services/api';
import Header from './components/Header';
import VideoSection from './components/VideoSection';
import SubscribeBar from './components/SubscribeBar';
import TrendingSection from './components/TrendingSection';
import NewsGrid from './components/NewsGrid';
import ArticleModal from './components/ArticleModel';
import AdColumn from './components/AdColumn';
import Footer from './components/Footer';
import NotificationTicker from './components/NotificationTicker';

function App() {
  const [trendingArticles, setTrendingArticles] = useState([]);
  const [selectedArticle, setSelectedArticle]   = useState(null);
  const [lastUpdated, setLastUpdated]           = useState('');
  const [language, setLanguage]                 = useState('en');

  useEffect(() => {
    loadTrending();
  }, []);

  const loadTrending = async () => {
    try {
      // ── SSR path — use Django-injected data (fastest, no network call) ──
      if (window.__INITIAL_DATA__) {
        const { trending, articles, lastUpdated: lu } = window.__INITIAL_DATA__;

        const trendingList = trending
          || (articles ? transformArticles(articles).slice(0, 10) : []);

        setTrendingArticles(trendingList);
        if (lu) setLastUpdated(lu);

        // Remove trending from __INITIAL_DATA__ — NewsGrid still needs articles
        delete window.__INITIAL_DATA__.trending;
        return;
      }

      // ── Fallback — fetch if SSR data not available ──
      const data = await getTrendingArticles();
      setTrendingArticles(transformArticles(Array.isArray(data) ? data : data.results || []));
    } catch (err) {
      console.error('Error loading trending articles:', err);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day:   'numeric',
      year:  'numeric',
    });
  };

  const truncateText = (text, maxLength) => {
    if (!text) return '';
    return text.length <= maxLength ? text : text.substr(0, maxLength) + '…';
  };

  const handleCardClick = async (articleId) => {
    try {
      await trackArticleClick(articleId);
      setTrendingArticles(prev =>
        prev.map(a =>
          a.id === articleId
            ? { ...a, click_count: (a.click_count || 0) + 1 }
            : a
        )
      );
    } catch (err) {
      console.error('Error tracking click:', err);
    }
  };

  return (
    <div className="app">
      <Header lastUpdated={lastUpdated} language={language} onLanguageChange={setLanguage} />
      <SubscribeBar />
      <NotificationTicker />
      <VideoSection />

      <div className="main-container">
        <AdColumn position="left" />

        <TrendingSection
          articles={trendingArticles}
          onArticleClick={setSelectedArticle}
          truncateText={truncateText}
          formatDate={formatDate}
          onCardClick={handleCardClick}
        />

        <NewsGrid
          onArticleClick={setSelectedArticle}
          formatDate={formatDate}
          truncateText={truncateText}
          onCardClick={handleCardClick}
          language={language}
        />

        <AdColumn position="right" />
      </div>

      {selectedArticle && (
        <ArticleModal
          article={selectedArticle}
          onClose={() => setSelectedArticle(null)}
          formatDate={formatDate}
        />
      )}
      <Footer />
    </div>
  );
}

export default App;